import Vue from 'vue'
import Vuex from 'vuex'
import { User } from './modules/user'
import home from './modules/home'
import record from './modules/record';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    User,
    home,
    record
  }
})
